import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../../data/faqs';
export function FaqList() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <ul className="space-y-3" data-id="element-158" data-mp="3var8yvdltlyp">
      {faqs.map((faq, index) => {
      const isOpen = openIndex === index;
      const panelId = `faq-panel-${index}`;
      return <li key={faq.question} className={`rounded-2xl border bg-steel transition-colors duration-150 ${isOpen ? 'border-flame' : 'border-edge'}`} data-id="element-159" data-mp="942pfkvggnlz" data-mpi={index}>
            <h3 data-id="element-160" data-mp="iu5g3ef3tph5">
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left text-lg font-semibold text-chalk md:text-xl" data-id="element-161" data-mp="iunjcv06p3yk">
                {faq.question}
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ${isOpen ? 'border-flame bg-flame text-ink' : 'border-edge text-flame'}`} data-id="element-162" data-mp="2um6gap7efhrm">
                  <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out-strong ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-163" data-mp="39j744hmgyskt" />
                </span>
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-164" data-mp="3n9u227keoefu">
              {isOpen && <motion.div id={panelId} initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-165" data-mp="3nbwpcju6btgv">
                  <p className="mx-6 mb-6 max-w-2xl border-l-4 border-flame pl-5 leading-relaxed text-muted" data-id="element-166" data-mp="225d0ks4lo01l">
                    {faq.answer}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}